<div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">

  <div class="flex flex-col gap-4 md:w-1/2">
    <in-home-care-reports></in-home-care-reports>

    <div class="flex flex-row gap-6 items-center">
      <span>Upload Licenses</span>
      <input type="file" style="display: none;" (change)="uploadData($event, true)" #ihcUpload />
      <div class="flex flex-row gap-2">
        <div class="file-upload">
          <button mat-button color="primary" class="upload-btn" (click)="ihcUpload.click()"
                  matTooltip="Upload Licenses" matTooltipShowDelay="500" matTooltipHideDelay="200">
            Upload
            <mat-icon>upload</mat-icon>
          </button>
        </div>
      </div>

      <span>Upload Branches</span>
      <input type="file" style="display: none;" (change)="uploadData($event, false)" #branchUpload />
      <div class="flex flex-row gap-2">
        <div class="file-upload">
          <button mat-button color="primary" class="upload-btn" (click)="branchUpload.click()"
                  matTooltip="Upload Branches" matTooltipShowDelay="500" matTooltipHideDelay="200">
            Upload
            <mat-icon>upload</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <mat-card class="md:w-1/2">
    <mat-card-header>
      <mat-card-title>
        <span class="font-semibold text-xl">Manage Reference Documents</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <document [entityId]="0"
                [entityType]="ihcReference"
                [statuses]="[]"
                [types]="referenceTypes"
                [editable]="true"
                [isReference]="true">
      </document>
    </mat-card-content>
  </mat-card>
</div>
